import React from 'react';
import { formatCurrency, ShoppingCarIcon } from '@avila-tek/ui/src';
import { motion } from 'framer-motion';
import Link from 'next/link';
import { ShopCart } from '../../../models';

interface FloatingCartButtonProps {
  shopCart: ShopCart;
}

function FloatingCartButton({ shopCart }: FloatingCartButtonProps) {
  const totalOfShopCart = React.useMemo(() => {
    const totalCost = shopCart?.products.reduce(
      (sum, item) => sum + item.price,
      0
    );
    return totalCost;
  }, [shopCart]);
  if (totalOfShopCart === 0) return null;
  return (
    <Link href="/shopping">
      <motion.button
        type="button"
        initial={{ width: '0px' }} // Tamaño inicial del botón
        animate={{ width: '250px' }} // Tamaño expandido para revelar el texto
        transition={{ duration: 0.5, ease: 'easeInOut' }} // Control de la animación
        className="text-white py-2 px-4 rounded fixed bottom-24 right-4 bg-color-primary-300  flex flex-row items-center justify-center space-x-3 shadow-xl overflow-hidden"
      >
        <ShoppingCarIcon className="w-5" />
        <motion.h1
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.3 }} // Control de la animación para el texto
          className="flex items-center"
        >
          <div className="flex flex-row justify-center items-center space-x-2 text-nowrap">
            <h1>Ir al carrito</h1>
            <span className="font-normal">
              ${formatCurrency(totalOfShopCart)}
            </span>
          </div>
        </motion.h1>
      </motion.button>
    </Link>
  );
}

export default FloatingCartButton;
